import { useCallback } from 'react';

import { type Channel } from 'src/data/channel';
import { useEffectOnce } from 'src/lib/hooks';
// @ts-expect-error - no TypeScript definitions yet
import { usePopups } from 'src/lib/popups';

import { type MetaConnectChoice } from './lib';
import { MetaConnectChoicePopup } from './MetaConnectChoicePopup';

export const META_CONNECT_CHOICE_POPUP = Symbol('META_CONNECT_CHOICE');

interface OpenParams {
  channel: Channel;
}

export const useMetaConnectChoicePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(META_CONNECT_CHOICE_POPUP, MetaConnectChoicePopup);
  });

  return useCallback(
    ({ channel }: OpenParams): Promise<MetaConnectChoice | undefined> => {
      return new Promise((resolve) => {
        popups.openPopup(META_CONNECT_CHOICE_POPUP, {
          channel,
          onResolve: resolve,
          onClose: () => {
            popups.closePopup(META_CONNECT_CHOICE_POPUP);
            resolve(undefined);
          },
        });
      });
    },
    [popups]
  );
};
